export const CONTENT_API = 'https://content.orionstereo.org'
export const BLOG_API = 'https://blog.orionstereo.org/ghost/api/v3/content'
export const KEY = '75910323fd7ab20a98b0cdd227'
export const PUSH_API = 'https://push.orionstereo.org'
